import React from 'react';
import './Pagination.scss'

const Pagination = ({ pageNumbers, handlePageLink, prevPage, nextPage, totalProfile, activePage, className = '' }) => {
    return (
        <div className={`flex gap-6 items-center m-4 mt-6 p-2 pagination-wrap ${className}`.trim()}>
            <div className='text-[#6b7280] font-[600] text-base'>Total {totalProfile}</div>
            <nav>
                <ul className='flex justify-center items-center'>
                    <li onClick={prevPage} className='pagination-paper mr-2'><img src='/svg/prev.svg' alt='prev' /></li>
                    {pageNumbers.map((number, i) => (
                        <li key={i} onClick={(event) => handlePageLink(event, number)} className={`pagination-paper cursor-pointer text-sky-900 ${activePage === number ? 'pagination-paper-inactive': ''}`}>
                            <span>{number}</span>
                        </li>
                    ))}
                    <li onClick={nextPage} className='pagination-paper ml-2'><img src='/svg/next.svg' alt='prev' /></li>
                </ul>
            </nav>
        </div>
    )
}

export default Pagination
